import React, { Fragment, useContext, useState } from "react";
import Img from "gatsby-image";
import SiteOverlay from "./site-overlay";
import AuthContext from "../services/firebase/auth-context/provider";
import { getItem, hasItem, setItem, testStorage } from "../services/cache/cache";
import { useActivePopup } from "../hooks/use-active-popup";
var AdPopup = function AdPopup() {
    var popup = useActivePopup();
    var authContext = useContext(AuthContext);
    var _useState = useState(true), overlayStatus = _useState[0], setOverlayStatus = _useState[1];
    var authenticated = authContext[0].authenticated;
    var onOverlayClose = function onOverlayClose() {
        return setOverlayStatus(false);
    };
    var showByInterval = function showByInterval(id, interval) {
        if (hasItem("LOCAL_STORAGE", "AD_POPUP", id)) {
            var savedDate = new Date(getItem("LOCAL_STORAGE", "AD_POPUP", id));
            var calculatedDateShort = new Date(savedDate);
            calculatedDateShort.setSeconds(savedDate.getSeconds() + 3);
            var calculatedDateInterval = new Date(savedDate);
            calculatedDateInterval.setDate(savedDate.getDate() + interval);
            return new Date() < calculatedDateShort || // Bugfix: If the site is re-rendered in three seconds we'll show the popup
                new Date() > calculatedDateInterval;
        }
        return true;
    };
    var show = !!popup && (popup.targetGroup == "Alle" || popup.targetGroup == "Abonnenten" && authenticated || popup.targetGroup == "Nicht-Abonnenten" && !authenticated) && showByInterval(popup === null || popup === void 0 ? void 0 : popup.id, popup === null || popup === void 0 ? void 0 : popup.interval) && testStorage("LOCAL_STORAGE");
    if (show) {
        setItem("LOCAL_STORAGE", "AD_POPUP", popup === null || popup === void 0 ? void 0 : popup.id, new Date());
        var maxWidth = popup.maxWidth ? popup.maxWidth : popup.image.fluid.width < 600 ? popup.image.fluid.width : 600;
        return /*#__PURE__*/ React.createElement(SiteOverlay, {
            onClose: onOverlayClose,
            open: overlayStatus,
            maxWidthContent: maxWidth
        }, /*#__PURE__*/ React.createElement("a", {
            href: popup.link,
            className: "relative block"
        }, /*#__PURE__*/ React.createElement(Img, {
            fluid: popup.image.fluid,
            alt: popup.image.alt
        }), popup.buttonText && /*#__PURE__*/ React.createElement("div", {
            className: "absolute inset-x-0 text-center",
            style: {
                bottom: "15px"
            }
        }, /*#__PURE__*/ React.createElement("button", {
            className: "font-medium border-2 border-makroOrange bg-makroOrange rounded-sm px-3 py-1 text-white-important hover:text-makroOrange-important hover:bg-transparent"
        }, popup.buttonText))));
    }
    return /*#__PURE__*/ React.createElement(Fragment, null);
};
export default AdPopup;
